export default {
  variants: [
    {
      props: { variant: "filled" },
      style: {
        fontFamily: "ey_interstate",
        fontSize: "10px",
        fontWeight: 300,
      },
    },
    {
      props: { variant: "clear" },
      style: {
        fontFamily: "ey_interstate",
        fontSize: "13px",
        fontWeight: 300,
        borderColor: "transparent",
        backgroundColor: "transparent",
        color: "#2E2E38",
      },
    },
  ],
};
